module.exports = __webpack_public_path__ + "img/buy_store_icon.34bf08d2.png";